



















import { getQuestProgress } from '@/game/infos/firestoreFiles';
import { MainQuestCode, mainQuests } from '@/game/infos/questMain';
import { QuestType } from '@/game/infos/unlockModels';
import userx from '@/store/modules/userx';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import QuestComponent from './quests/QuestComponent.vue';

export interface QuestStatus {
  code: number;
  type: QuestType;
  completed: boolean;
  claimable: boolean;
}
@Component({
  components: {
    QuestComponent,
  },
})
export default class MainQuestPanel extends Vue {
  public allMainQuestCodes = [
    MainQuestCode.UnlockSf1,
    MainQuestCode.UnlockSkin10,
    MainQuestCode.EmailVerify,
  ];
  public mainQuests = mainQuests;
  public totalMainQuests = 0;
  public completedMainQuests = 0;
  public get mainQuestStatus(): QuestStatus[] {
    const claimableQuests = userx.claimableQuests;
    const progresses = userx.userDoc.mainQuestProgress;
    const quests = mainQuests;
    const type = QuestType.Main;
    let total = 0;
    let numCompleted = 0;
    const list: QuestStatus[] = this.allMainQuestCodes.map((code) => {
      const claimable = claimableQuests.find(
        (q) => q.type === type && q.code === code,
      )
        ? true
        : false;

      const progressA = getQuestProgress(progresses, code);
      const completed = progressA.currentStep >= quests[code].steps.length;
      if (completed) {
        numCompleted++;
      }
      total++;
      return {
        code,
        claimable,
        type,
        completed,
      };
    });
    this.totalMainQuests = total;
    this.completedMainQuests = numCompleted;
    list.sort((a, b) => {
      if (a.claimable !== b.claimable) {
        if (a.claimable) {
          return -1;
        }
        return 1;
      }
      if (a.completed !== b.completed) {
        if (a.completed) {
          return 1;
        }
        return -1;
      }
      return 0;
    });
    return list;
  }
}
